import CpBase from './CpBase.vue';
import CpLogin from './CpLogin.vue';
import CpLoginCldy from './CpLoginCldy.vue';
import CpLoginVerz from './CpLoginVerz.vue';
import CpLoginCpanel from './CpLoginCpanel.vue';
import CpDomainList from './CpDomainList.vue';
import CpDomainDetail from './CpDomainDetail.vue';
import CpDnsEditor from './CpDnsEditor.vue';

export default {
  CpBase,
  CpLogin,
  CpLoginCldy,
  CpLoginVerz,
  CpLoginCpanel,
  CpDomainList,
  CpDomainDetail,
  CpDnsEditor,
};
